<app-dialog class="confirmation-dialog-v2" [hideClose]="true">
  <ng-container dialog-content>
    <div class="header-close-wrapper">
      <h4 class="header">
        {{ dialogData.title }}
      </h4>
      <span class="fa fa-times" (click)="closeModal()"></span>
    </div>

    <div class="confirmation-content">
      <div *ngIf="dialogData.hasError" class="icon-container">
        <app-svg-icon class="error-icon" [src]="errorIcon"></app-svg-icon>
      </div>
      <div class="description-text" [innerHTML]="dialogData.descriptionText"></div>
      <div class="button-container">
        <button *ngIf="dialogData.confirmText" class="btn btn-primary confirm-btn" (click)="closeModal()">
          {{ dialogData.confirmText }}
        </button>
      </div>
    </div>
  </ng-container>
</app-dialog>
